export default __webpack_public_path__ + "static/media/Desert orange_primary.3463c90e.jpg";